import TransferUpahProduksiAsetApi from './TransferUpahProduksiAsetApi';

export default TransferUpahProduksiAsetApi;
